/** Classe no <html> enquanto o diálogo de impressão do Gantt está aberto. */
export const PRINTING_GANTT_CLASS = "printing-gantt";

const EXPORTED_AT_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

/** "Exportado em dd/mm/aaaa hh:mm por <usuário>", igual ao PDF do core; sem nome, omite o "por". */
export function formatExportedLabel(
  name: string | null | undefined,
  now: Date = new Date(),
): string {
  const parts = Object.fromEntries(
    EXPORTED_AT_FORMATTER.formatToParts(now).map(({ type, value }) => [type, value]),
  );
  const when = `${parts.day}/${parts.month}/${parts.year} ${parts.hour}:${parts.minute}`;
  const trimmed = name?.trim();
  return trimmed ? `Exportado em ${when} por ${trimmed}` : `Exportado em ${when}`;
}

const GANTT_PAGE_STYLE_ID = "gantt-print-page-style";

/**
 * Rodapé "Página X de Y" do PDF do Gantt. Vai numa caixa de margem do `@page` porque o contador
 * do navegador ("1/2") não tem como ganhar a palavra "Página". Ao definir caixas de margem, o
 * navegador deixa de imprimir o cabeçalho/rodapé dele (data, título da aba, endereço e o "1/2"):
 * as caixas vazias garantem isso. Só vale durante a impressão do Gantt.
 */
const GANTT_PAGE_CSS = `@page {
  @top-center { content: " "; }
  @bottom-left { content: " "; }
  @bottom-right {
    content: "Página " counter(page) " de " counter(pages);
    font-family: Helvetica, Arial, sans-serif;
    font-size: 8pt;
    color: #475569;
  }
}`;

/** Instala o `@page` do Gantt e devolve o que o remove depois da impressão. */
function installGanttPageStyle(): () => void {
  const style = document.createElement("style");
  style.id = GANTT_PAGE_STYLE_ID;
  style.media = "print";
  style.textContent = GANTT_PAGE_CSS;
  document.head.append(style);

  return () => style.remove();
}

function openPrintView(title: string, printingClass: string, onRestore?: () => void): void {
  const previousTitle = document.title;
  document.title = title;
  document.documentElement.classList.add(printingClass);

  const restore = () => {
    document.title = previousTitle;
    document.documentElement.classList.remove(printingClass);
    onRestore?.();
    window.removeEventListener("afterprint", restore);
  };
  window.addEventListener("afterprint", restore);

  window.setTimeout(() => {
    window.print();
  }, 0);
}

/**
 * Abre o diálogo nativo de impressão da página atual (Gantt).
 * O título vira o nome sugerido do PDF. Espera um tick para o modal de
 * exportação desmontar antes de imprimir.
 */
export function printGanttView(title: string): void {
  openPrintView(title, PRINTING_GANTT_CLASS, installGanttPageStyle());
}
